import React from 'react'

interface ChallengeCardSkeletonProps {
  /** Number of skeleton cards to display */
  count?: number
}

const SkeletonBar: React.FC<{ width?: string; height?: string; className?: string }> = ({ 
  width = 'w-full', 
  height = 'h-4',
  className = ''
}) => (
  <div className={`bg-secondary/20 rounded animate-pulse ${width} ${height} ${className}`} />
)

const ChallengeCardSkeleton: React.FC<ChallengeCardSkeletonProps> = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          className="bg-card rounded-lg shadow-sm border border-border p-6"
        >
          {/* Challenge Icon & Category */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-secondary/10 rounded-lg">
                <SkeletonBar width="w-6" height="h-6" />
              </div>
              <SkeletonBar width="w-16" height="h-3" />
            </div>
            
            {/* Difficulty Badge */}
            <SkeletonBar width="w-20" height="h-6" className="rounded-full" />
          </div>

          {/* Challenge Title */}
          <div className="mb-3 h-12 flex items-start">
            <div className="space-y-2 w-full">
              <SkeletonBar width="w-3/4" height="h-5" />
              <SkeletonBar width="w-1/2" height="h-4" />
            </div>
          </div>

          {/* Challenge Description */}
          <div className="mb-4 space-y-2">
            <SkeletonBar width="w-full" height="h-4" />
            <SkeletonBar width="w-5/6" height="h-4" />
            <SkeletonBar width="w-2/3" height="h-4" />
          </div>

          {/* Estimated Time */}
          <div className="flex items-center mb-6 space-x-2">
            <SkeletonBar width="w-4" height="h-4" />
            <SkeletonBar width="w-24" height="h-3" />
            <SkeletonBar width="w-2" height="h-3" />
            <SkeletonBar width="w-20" height="h-3" />
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-3">
            <SkeletonBar width="w-full" height="h-10" className="rounded-md" />
            <SkeletonBar width="w-10" height="h-10" className="rounded-md" />
          </div>
        </div>
      ))}
    </>
  )
}

export { ChallengeCardSkeleton }
